export enum NovaPluginIds {
    IR = "hotspot",
    LiveVideo = "livevideo",
    Ortho = "orthomosaic",
    Video = "video",
    Perimeter = "perimeter",
    Colorfinder = "colorfinder",
    Panorama = "panorama",
    Icon = "icon",
    Satellite = "satellite",
}
export const PluginNameMap: Record<NovaPluginIds, string> = {
    [NovaPluginIds.IR]: "Hotspots",
    [NovaPluginIds.Ortho]: "Orthomosaic",
    [NovaPluginIds.Video]: "Video",
    [NovaPluginIds.Perimeter]: "Fire Perimeter",
    [NovaPluginIds.Colorfinder]: "Colorfinder",
    [NovaPluginIds.Panorama]: "Panorama",
    [NovaPluginIds.LiveVideo]: "Live Stream",
    [NovaPluginIds.Icon]: "Icon",
    [NovaPluginIds.Satellite]: "Satellite Mosaic",
}
